/* eslint-disable import/prefer-default-export */
import { useParams } from "react-router-dom"

const useLanguage = () => {
    const { locale } = useParams()
    return locale
}

export { useLanguage }
